import loadable from '@loadable/component';

export const OrgDashboardViewGradFairInviteContainerLoadable = loadable(
  () => import('./OrgDashboardViewGradFairInviteContainer'),
  {
    resolveComponent: (module) =>
      module.OrgDashboardViewGradFairInviteContainer,
  },
);
